import { FC, memo, useState } from 'react';

import { FallbackedLayout } from '@/common/layouts';

import { useGetByIdSearchConsoleAccountsQuery } from '@/modules/DomainsApi';

import { SearchConsoleAccountOTPView } from './SearchConsoleAccountOTPView';


interface Props {
  searchConsoleAccountId: string;
}

export const SearchConsoleAccountOTPContainer: FC<Props> = memo(({ searchConsoleAccountId }) => {
  const [mode, setMode] = useState<'view' | 'create'>('view');
  const [refreshInterval, setRefreshInterval] = useState(0);

  const {
    data: searchConsoleAccountData,
    error: searchConsoleAccountError,
    isFetching: isSearchConsoleAccountFetching,
    isError: isSearchConsoleAccountError,
  } = useGetByIdSearchConsoleAccountsQuery(searchConsoleAccountId)({
    enabled: !!searchConsoleAccountId,
    onSuccess: (data) => {
      if (data.isOtpSetted) {
        setRefreshInterval(data.otpAuthenticator!.period);
      }
    }
  });

  const handleSetViewMode = () => {
    setMode('view');
  };

  const handleSetCreateMode = () => {
    setMode('create');
  };

  return (
    <FallbackedLayout
      isLoading={ isSearchConsoleAccountFetching }
      isError={ isSearchConsoleAccountError }
      error={ searchConsoleAccountError }
      data={ searchConsoleAccountData }
    >
      { ({ isOtpSetted }) => (
        <SearchConsoleAccountOTPView
          searchConsoleAccountId={ searchConsoleAccountId }
          isOtpSetted={ isOtpSetted }
          refreshInterval={ refreshInterval }
          mode={ mode }
          handleSetCreateMode={ handleSetCreateMode }
          handleSetViewMode={ handleSetViewMode }
        />
      ) }
    </FallbackedLayout>
  );
});
